function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Group 181"
}, React.createElement("g", {
  "data-name": "Group 179"
}, React.createElement("path", {
  "data-name": "Path 111",
  d: "M9 18a9.01 9.01 0 01-9-9 9.01 9.01 0 019-9 9.011 9.011 0 019 9 9.01 9.01 0 01-9 9zM9 1.3A7.709 7.709 0 001.3 9 7.71 7.71 0 009 16.7 7.709 7.709 0 0016.7 9 7.709 7.709 0 009 1.3z",
  fill: "#0d5a91"
})), React.createElement("g", {
  "data-name": "Group 180"
}, React.createElement("path", {
  "data-name": "Path 112",
  d: "M12.862 5.297a.305.305 0 00-.371.074l-.689.683a4.12 4.12 0 00-1.3-.829 3.992 3.992 0 00-1.507-.294 3.95 3.95 0 00-1.579.324 4.1 4.1 0 00-1.3.868 4.1 4.1 0 00-.869 1.3 3.952 3.952 0 00-.323 1.579 3.951 3.951 0 00.323 1.579 4.091 4.091 0 00.869 1.3 4.1 4.1 0 001.3.869 3.965 3.965 0 001.579.323 4.04 4.04 0 001.732-.384 3.984 3.984 0 001.4-1.083.175.175 0 00.039-.12.142.142 0 00-.05-.108l-.726-.731a.2.2 0 00-.132-.048.163.163 0 00-.122.064 2.673 2.673 0 01-.948.779 2.682 2.682 0 01-1.192.275 2.643 2.643 0 01-1.052-.215 2.716 2.716 0 01-.866-.58 2.716 2.716 0 01-.58-.866 2.643 2.643 0 01-.215-1.052 2.639 2.639 0 01.215-1.051 2.731 2.731 0 01.58-.867 2.744 2.744 0 01.866-.58 2.642 2.642 0 011.052-.214 2.632 2.632 0 011.849.726l-.732.731a.3.3 0 00-.074.365.317.317 0 00.313.212h2.374a.323.323 0 00.238-.1.325.325 0 00.1-.238V5.614a.316.316 0 00-.202-.317z",
  fill: "#0d5a91"
})));

var SvgBespokenRefreshIcon = function SvgBespokenRefreshIcon(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _ref);
};

export default SvgBespokenRefreshIcon;